import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/auth',
    name: 'authModule',
    meta: {
      title: 'The Hotels Network',
    },
    component: () => import(
      '@/modules/Auth/AuthModule.vue'
    ),
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(
          '@/modules/Auth/views/Login/Login.vue'
        ),
      },
      {
        path: '/logout',
        name: 'logout',
        meta: {
          requiresAuth: true,
        },
        component: () => import(
          '@/modules/Auth/views/Logout/Logout.vue'
        ),
      },
      {
        path: '/forgot',
        name: 'forgot',
        component: () => import(
          '@/modules/Auth/views/Forgot/Forgot.vue'
        ),
      },
      {
        path: '/reset-password',
        name: 'reset',
        component: () => import(
          '@/modules/Auth/views/Reset/Reset.vue'
        ),
      },
      {
        path: '/invite',
        name: 'invite',
        component: () => import(
          '@/modules/Auth/views/Invite/Invite.vue'
        ),
      },
      {
        path: '/internal',
        name: 'internalUserRedirect',
        component: () => import(
          '@/modules/Auth/views/Internal/InternalUserRedirect.vue'
        ),
      },
    ],
  },
];

export default routes;
